export default "__VITE_ASSET__aUuSemd$__"